import { render, staticRenderFns } from "./historical-declaration.vue?vue&type=template&id=56db55f4&scoped=true"
import script from "./historical-declaration.vue?vue&type=script&lang=js"
export * from "./historical-declaration.vue?vue&type=script&lang=js"
import style0 from "./historical-declaration.vue?vue&type=style&index=0&id=56db55f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56db55f4",
  null
  
)

export default component.exports